// Module
var code = "<div class=\"mxTooltip\" ch-popover=\"MxTooltip.popover\" ng-mouseleave=\"MxTooltip.mouseleave()\"> <span class=\"mxTooltip__Text\"> <ng-transclude></ng-transclude></span>&nbsp;<span class=\"mxTooltip__Icon\"> <dls-icon-tooltip></dls-icon-tooltip> </span> </div> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/components/tooltips/mxTooltip/mxTooltip.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;